/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import {
  Card,
  CardTitle,
  CardText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Spinner,
} from "reactstrap";

// Redux
import { useSelector, useDispatch } from "react-redux";

//Importation of commom component to charge initials instead src/
import ProfilePictureLogic from "../../../../../../../../../../../Common/ProfilePicture";
import BadgesEllipsisSoft from "../../../../../../../../../../../../components/Common/BadgesEllipsisSoft";

import toastr from "toastr";

import "./AgentCard.scss";

import { updateAvailabilityAgent } from "../../../../../../../../../../../../store/availability/actions";

//i18n
import { withTranslation } from "react-i18next";
import ButtonLogout from "../ButtonLogout";

const index = ({ t, ...props }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  const [statusOption, setStatusOption] = useState(false);
  const { successUpdateAvailabilityAgent, errorAvailability } = useSelector(
    (state) => state.Availability
  );

  const [dropdownOpenAway, setdropdownOpenAway] = useState(false);
  const [dropdownOpenBacksoon, setDropdownOpenBacksoon] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleAway = () => setdropdownOpenAway(!dropdownOpenAway);
  const toggleBacksoon = () => setDropdownOpenBacksoon(!dropdownOpenBacksoon);

  const dispatch = useDispatch();

  const onClickStatus = () => {
    setStatusOption(!statusOption);
  };

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
    toastr[type](message);
  };

  useEffect(() => {
    if (successUpdateAvailabilityAgent) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      props?.handleRefresh();
      showToast("success", t("Agent status has been updated"));
    }
  }, [successUpdateAvailabilityAgent, t, props]);

  useEffect(() => {
    if (errorAvailability) {
      setLoading(false);
    }
  }, [errorAvailability]);

  const handleUpdateStatus = (availId, agentId) => {
    availId && dispatch(updateAvailabilityAgent(availId, agentId));
  };

  const showListStatus = () => {
    const online = props?.agentAvailability.find((el) => el.name === "Online");
    const backsoon = props?.agentAvailability.find(
      (el) => el.name === "Volto logo"
    );
    const away = props?.agentAvailability.find((el) => el.name === "Ausente");

    return (
      <div className={`status-control ${mainTheme}`}>
        <div id="status-icon">
          <i
            id="status-icon"
            className={`bx bxs-check-circle text-success align-self-center px-1 ${
              props?.agentStatus === "online"
                ? `status-selected ${mainTheme}`
                : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              setLoading(true);
              handleUpdateStatus(online.id, props?.agentId);
            }}
          />
        </div>

        {backsoon?.children?.length > 0 ? (
          <div
            id="status-icon"
            className={
              props?.agentStatus === "backsoon"
                ? `status-selected ${mainTheme}`
                : ""
            }
          >
            <Dropdown isOpen={dropdownOpenBacksoon} toggle={toggleBacksoon}>
              <DropdownToggle
                className="d-flex h-100 dropdown-item avilability p-0 caret text-muted  align-self-center rounded-0"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <i
                  name="backsoon"
                  className="d-flex bx bxs-time-five align-self-center text-warning mr-1"
                />
                <i className="d-flex mdi mdi-chevron-down align-self-center"></i>
              </DropdownToggle>

              <DropdownMenu style={{ height: "150px" }} className="scroll">
                {backsoon?.children.map((child, key) => {
                  return (
                    <div
                      className="d-flex user-chat dropdown-item btn"
                      key={key}
                      onClick={(e) => {
                        handleUpdateStatus(child?.id, props?.agentId);
                        setLoading(true);
                      }}
                    >
                      <i className="d-flex bx bxs-time-five align-self-center text-warning mr-1"></i>
                      {child.name}
                    </div>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
          </div>
        ) : (
          <div id="status-icon">
            <i
              className={`mr-1 ml-1 bx bxs-time-five text-warning ${
                props?.agentStatus === "online"
                  ? `status-selected ${mainTheme}`
                  : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                setLoading(true);
                handleUpdateStatus(backsoon?.id, props?.agentId);
              }}
            />
          </div>
        )}

        {away?.children?.length > 0 ? (
          <div
            id="status-icon"
            className={props?.agentStatus === "away" ? "status-selected" : ""}
          >
            <Dropdown isOpen={dropdownOpenAway} toggle={toggleAway}>
              <DropdownToggle
                className="d-flex h-100 dropdown-item avilability p-0 caret text-muted align-self-center rounded-0"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <i
                  name="away"
                  className="d-flex bx bxs-minus-circle align-self-center text-danger mr-1"
                />
                <i className="d-flex mdi mdi-chevron-down align-self-center"></i>
              </DropdownToggle>

              <DropdownMenu
                style={{ height: "150px", overflow: "auto" }}
                className="scroll"
              >
                
                {away?.children.map((child, key) => {
                  return (
                    <div
                      className="d-flex user-chat dropdown-item btn"
                      key={key}
                      onClick={(e) => {
                        handleUpdateStatus(child?.id, props?.agentId);
                        setLoading(true);
                      }}
                    >
                      <i className="d-flex bx bxs-minus-circle align-self-center text-danger mr-1"></i>
                      {child.name}
                    </div>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
          </div>
        ) : (
          <div id="status-icon">
            <i
              className={`mr-1 ml-1 bx bxs-minus-circle text-danger ${
                props?.agentStatus === "online" ? "status-selected" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                setLoading(true);
                handleUpdateStatus(away?.id, props?.agentId);
              }}
            />
          </div>
        )}
        {loading && (
          <div className="d-flex flex-column justify-content-center px-1">
            <Spinner animation="border" size="sm" />
          </div>
        )}
      </div>
    );
  };

  return (
    <Card className={`agent-card-wrapper ${mainTheme}`} body>
      <div className="agent-card-header mb-3">
        <ButtonLogout id={props.agentId} isCard />
        <div id="agent-initials-avatar-wrapper">
          <div className="agent-initial-badge d-flex justify-content-center pl-2">
            <div className="agent-initial-text text-capitalize">
              <ProfilePictureLogic
                onClick={onClickStatus}
                name={props.agentName}
                statusProps={props.agentStatus}
                isProfile={true}
                src={props.agentAvatar}
                t={t}
              />
            </div>
          </div>
          {statusOption ? showListStatus() : ""}
        </div>

        <div id="agent-fullname-wrapper">
          <div className="agent-name justify-content-center ml-4">
            {props.agentName}
          </div>
          <div className="justify-content-center font-size-10 mb-2 ml-4 gp-3">
            {props.agentStatus === "backsoon" && ( t("Volto logo") + " - ")}
            {props.agentStatusDescription}
          </div>
          <div className="agent-time d-flex ml-auto mt-2">
            <p>{props.agentTime}</p>
          </div>
        </div>
      </div>  

      <div className="skills-container mb-2">
        <BadgesEllipsisSoft
          objItems={
            [...props?.skills]
              ?.sort((a, b) => (a.length < b.length ? 1 : -1))
              .map((sk) => ({ name: sk })) || []
          }
          showDynamic={true}
          tooltipBigName={20}
          isTooltip
        />
      </div>

      <div className="d-flex w-100 flex-wrap justify-content-between">
        <div className="d-flex justify-content-between text-muted mb-2">
          <div className="d-flex text-left mr-2">{`${t("Capacity")}:`}</div>
          <div className="d-flex text-right agent-value">
            {props.agentCapacity}
          </div>
        </div>
        <div className="d-flex justify-content-between text-muted mb-2">
          <div className="d-flex text-left mr-2">{`${t("CSAT")}:`}</div>
          <div className="d-flex text-right agent-value">{props.agentCSAT}</div>
        </div>
      </div>

      <div className="d-flex w-100 flex-wrap justify-content-between">
        <div className="d-flex justify-content-between text-muted mb-2">
          <div className="d-flex text-left mr-2">{`${t(
            "Status Duration"
          )}:`}</div>
          <div className="d-flex text-right agent-value">
            {props.agentStateDuration}
          </div>
        </div>
        <div className="d-flex justify-content-between text-muted mb-2">
          <div className="d-flex text-left mr-2">{`${t("Max.Chat")}:`}</div>
          <div className="d-flex text-right agent-value">{props.max_chats}</div>
        </div>
      </div>

      <div className="row border-top-gray">
        <div className="col-4 text-center border-right-gray">
          <div id="assigned-messages">{t("Assigned")}</div>
          <div className="agent-value">{props.assignedMessages}</div>
        </div>
        <div className="col-4 text-center">
          <div id="closed-messages">{t("Closed")}</div>
          <div className="agent-value">{props.closedMessages}</div>
        </div>
        <div className="col-4 text-center border-left-gray">
          <div id="activated-messages">{t("Open")}</div>
          <div className="agent-value">{props.activatedMessages}</div>
        </div>
      </div>
    </Card>
  );
};

export default withTranslation()(index);
